import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=0f634894&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./dialog.vue?vue&type=style&index=0&id=0f634894&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f634894",
  null
  
)

export default component.exports